import * as THREE from 'three';

/**
 * @param {number} [colorHex]
 * @returns {THREE.MeshStandardMaterial}
 */
export function createRoomCeilingMaterial(colorHex = 0xffffff) {
  return new THREE.MeshStandardMaterial({
    color: colorHex,
    roughness: 0.9,
    metalness: 0,
    side: THREE.FrontSide,
  });
}

/**
 * Lay the room shape flat at ceiling height with its front face toward room interior (-Y).
 * @param {THREE.BufferGeometry} geometry
 */
export function orientCeilingGeometryForInteriorView(geometry) {
  geometry.rotateX(Math.PI / 2);
  geometry.computeVertexNormals();

  const sampleNormal = new THREE.Vector3();
  if (geometry.attributes.normal?.count > 0) {
    sampleNormal.fromBufferAttribute(geometry.attributes.normal, 0);
  }

  if (sampleNormal.y > 0) {
    geometry.scale(1, -1, 1);
    geometry.computeVertexNormals();
  }
}

/**
 * @param {THREE.Mesh} mesh
 * @returns {THREE.Vector3 | null}
 */
export function sampleCeilingWorldNormal(mesh) {
  if (!mesh?.geometry?.attributes?.normal) return null;
  mesh.geometry.computeVertexNormals();
  mesh.updateMatrixWorld(true);
  const normal = new THREE.Vector3();
  normal.fromBufferAttribute(mesh.geometry.attributes.normal, 0);
  normal.transformDirection(mesh.matrixWorld);
  return normal;
}
